module.exports = __webpack_public_path__ + "img/logo_8.89c9ae4a.png";